import React from "react";
import i18n from "../../../../constants/i18n";
import {
  DEVELOPER_STATS_DASHBOARD_PAYMENT_PACKAGES_HEADERS,
  DEVELOPER_STATS_DASHBOARD_PACKAGE_NOTIFICATION_TYPE_COUNT_HEADERS,
  DEVELOPER_STATS_DASHBOARD_USERS_DATA_HEADERS,
  DEVELOPER_STATS_DASHBOARD_SUBSCRIPTIONS_AND_PURCHASES_HEADERS,
  DEVELOPER_STATS_DASHBOARD_ON_CALL_HEADERS
} from "../../../../constants/table-custom-headers/Developers";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getStatsStore from "../../../../stores/developer-store/stats-store";

const StatsDashboardData = withLiteObserverAndTheme(() => {
  const usersData = getStatsStore().usersData.get();
  const usersSubscriptionsAndPurchases =
    getStatsStore().usersSubscriptionsAndPurchases.get();
  const onCallData = getStatsStore().onCallData.get();
  const paymentPackages = getStatsStore().paymentPackages.get();
  const paymentPackagesToday = getStatsStore().paymentPackagesToday.get();
  const packageByType = getStatsStore().packageByTypeCount.get();
  return (
    <React.Fragment>
      <Et3Table
        columns={DEVELOPER_STATS_DASHBOARD_USERS_DATA_HEADERS}
        rows={usersData}
        title={i18n.get("USERS_DATA")}
        shouldBeFlagged={false}
        titleKey={"USERS_DATA"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DEVELOPER_STATS_DASHBOARD_SUBSCRIPTIONS_AND_PURCHASES_HEADERS}
        rows={usersSubscriptionsAndPurchases}
        title={i18n.get("USERS_PURCHASES_AND_SUBSCRIPTIONS")}
        shouldBeFlagged={false}
        titleKey={"USERS_PURCHASE_AND_SUBSCRIPTIONS"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DEVELOPER_STATS_DASHBOARD_ON_CALL_HEADERS}
        rows={onCallData}
        title={i18n.get("ON_CALL")}
        shouldBeFlagged={false}
        titleKey={"ON_CALL"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DEVELOPER_STATS_DASHBOARD_PAYMENT_PACKAGES_HEADERS}
        rows={paymentPackagesToday}
        title={i18n.get("PAYMENT_PACKAGES_TODAY")}
        shouldBeFlagged={false}
        titleKey={"PAYMENT_PACKAGES_FOR_LAST_DAY"}
      />

      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DEVELOPER_STATS_DASHBOARD_PAYMENT_PACKAGES_HEADERS}
        rows={paymentPackages}
        title={i18n.get("PAYMENT_PACKAGES_PREV_DAY")}
        shouldBeFlagged={false}
        titleKey={"PAYMENT_PACKAGES_FOR_LAST_DAY"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={
          DEVELOPER_STATS_DASHBOARD_PACKAGE_NOTIFICATION_TYPE_COUNT_HEADERS
        }
        rows={packageByType}
        title={i18n.get("PACKAGE_NOTIFICATION_TYPE_COUNT")}
        shouldBeFlagged={false}
        titleKey={"PACKAGES_NOTIFICATION_TYPE_COUNT_FOR_LAST_DAY"}
      />
    </React.Fragment>
  );
});

export default StatsDashboardData;
